import React from 'react'
import { BrowserRouter, Route, Switch, Link } from 'react-router-dom'
import PageLayout from 'layouts/PageLayout'

const AppRouter = () => {
  return (
    <BrowserRouter>
      <div className='dn'>
        {/* 入口地址，爬虫通过入口地址获取后续的路径生成静态页面 */}
        <Link to='/assistance/push' />
        <Link to='/festival/referral' />
        <Link to='/fission/referral' />
        <Link to='/merchant/promotion/invitee' />
        <Link to='/mobile-topup/topup-day' />
        <Link to='/voucher/ramadan' />
        <Link to='/voucher/share/invitee' />
      </div>
      <Switch>
        <Route
          path='/reward'
          render={(routeProps) => require('./Reward').default(routeProps)}
        />
        <Route
          path='/assistance'
          render={(routeProps) => require('./Assistance').default(routeProps)}
        />
        <Route
          path='/voucher'
          render={(routeProps) => require('./Voucher').default(routeProps)}
        />
        <Route
          path='/merchant'
          render={(routeProps) => require('./Merchant').default(routeProps)}
        />
        <Route
          path='/kyc'
          render={(routeProps) => require('./KYC').default(routeProps)}
        />
        <Route
          path='/festival'
          render={(routeProps) => require('./Festival').default(routeProps)}
        />
        <Route
          path='/fission'
          render={(routeProps) => require('./Fission').default(routeProps)}
        />
        <Route
          path='/mobile-topup'
          render={(routeProps) => require('./MobileTopUp').default(routeProps)}
        />
        <Route
          path='/unionpay'
          render={(routeProps) => require('./UnionPay').default(routeProps)}
        />
        <Route
          exact
          path='/login'
          render={(routeProps) => require('./Login').default(routeProps)}
        />
        <Route
          path='/'
          render={(routeProps) => (
            <PageLayout>
              {require('./Agreement').default(routeProps)}
              {require('./Agreements').default(routeProps)}
              {require('./AutoLogin').default(routeProps)}
              {require('./Huawei').default(routeProps)}
              {require('./FAQ').default(routeProps)}
              {require('./Expired').default(routeProps)}
              {require('./Benefit').default(routeProps)}
            </PageLayout>
          )}
        />
      </Switch>
    </BrowserRouter>
  )
}

export default AppRouter
